import React from 'react';
//import { IconInformation } from '../../img';//IconInformation
import ContentLoader from 'react-content-loader';
//import ReactTooltip from 'react-tooltip';
import './Integration.scss';
import Dropdown from 'react-dropdown';
import IntHeader from './IntHeader';

const TwitterPost = ({
  hideShowDataSource,
  userIntegration,
  handleStateChangeInt,
  data,
  loading,
  // handleIsActive,
  createTwitterUN,
  deleteTwitterUN,
  // arrDataSource,
  // handleDataSource,
  deleteTwitter,
  validator,
  // state,
  openCloseFilter,
  updateFilter,
  twitterOauth,
  handleStateChangeDrpDOWN
  // hideShowIntegration
}) => {

  const tagOptions = [
    { value: '@', label: '@' },
    { value: '#', label: '#' }
  ];

  const twitterAuthStorage = () => {
    // localStorage.setItem('W_WDGT_CRT', JSON.stringify({
    //   wdsc: state.wdsc,
    //   widgetById: state.widgetById,
    //   currLayoutId: state.currLayoutId,
    //   currCardId: state.currCardId,
    //   currHtnpp: state.currHtnpp,
    //   isEditWidget: state.isEditWidget,
    // }));
    twitterOauth();
  };

  userIntegration = userIntegration && userIntegration.length > 0 && userIntegration.filter(x => x.inm == 'twitterpost');
  let disableBTN = false;
  if (loading === true) {
    disableBTN = true;
  }
  else if (data.isCreatingIntegration === true) {
    disableBTN = data.isCreatingIntegration;
  }

  return (
    <div>
      <div className="title-dataset-select">
        {/* <div className="dataset-select-header" >
          <svg onClick={() => hideShowDataSource()} className="link-svg" xmlns="http://www.w3.org/2000/svg" width="12" height="20" viewBox="0 0 12 20">
            <path id="collsapn-arrow" d="M11.587,10.928,2.565,19.951a1.111,1.111,0,0,1-1.568,0l-.665-.665a1.111,1.111,0,0,1,0-1.568L7.909,10.14.324,2.557a1.111,1.111,0,0,1,0-1.568L.988.324a1.111,1.111,0,0,1,1.568,0l9.03,9.03a1.12,1.12,0,0,1,0,1.574Z" transform="translate(11.894 20) rotate(-177)" fill="#8FA7C4" />
          </svg>
          <div className="title-dataset-label cursor" onClick={() => hideShowDataSource()}>
            <img className="mr-2" src={data.img} alt="icon" />
            <h6>{data.dn}</h6>
          </div>
        </div> */}
        <IntHeader
          data={data}
          hideShowDataSource={hideShowDataSource}
        />
        {(!userIntegration || userIntegration.length == 0) &&
          <div className="integr-inside-hdright wdgt-dataset-form" style={{ width: '100%' }} onClick={() => twitterAuthStorage()}>
            <div className="add-integra-btn text-center" >
              <button disabled={disableBTN} className="nf-btn nf-btn-default">Login with Twitter</button>
            </div>
          </div>
        }
        {/* {(!userIntegration || userIntegration.length == 0) && <div className="add-integra-btn">
          <a className="nf-btn nf-btn-default" onClick={() => twitterOauth()}>Add New</a>
        </div>} */}
      </div>




      {loading === true ?
        <ContentLoader
          height={750}
          width={1750}
          speed={2}
          primaryColor="#fff"
          secondaryColor="#eceef4"
        >
          <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
        </ContentLoader>
        : <div className='app-list-sublistapp'>
          {
            // data.islstIntLoading === true ?
            //   <ContentLoader
            //     height={750}
            //     width={1750}
            //     speed={2}
            //     primaryColor="#fff"
            //     secondaryColor="#eceef4"
            //   >
            //     <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
            //   </ContentLoader>
            //   :
            userIntegration && userIntegration.length > 0 ?
              userIntegration.map((usInt, key) => {
                return (<div className="wdgt-group-block wdgt-group-twitter app-list-sublistapp" key={key}>
                  <div className='app-list-sublistapp-header'>
                    <label className='card-editor-title app-intigra-title'>
                      {usInt.d && usInt.d.name ? usInt.d.name : ''}
                      <svg style={{ marginLeft: '10px' }} xmlns="http://www.w3.org/2000/svg" width='16' height='14' viewBox="0 0 1082 879.125">
                        <path id="twitter" d="M1082,152.075A462.475,462.475,0,0,1,954.189,187.1a220.575,220.575,0,0,0,97.583-122.6,443.3,443.3,0,0,1-140.66,53.694A222.282,222.282,0,0,0,749.082,48c-122.807,0-221.675,99.679-221.675,221.878,0,17.583,1.488,34.489,5.14,50.583C348.133,311.467,184.954,223.081,75.334,88.44A221.878,221.878,0,0,0,143.5,384.908c-35.638-.676-70.6-11.023-100.22-27.32v2.434c0,107.794,76.89,197.33,177.718,217.955a221.392,221.392,0,0,1-58.158,7.3c-14.2,0-28.538-.812-42-3.787,28.741,87.845,110.3,152.427,207.271,154.523A445.705,445.705,0,0,1,53.086,830.624,415.471,415.471,0,0,1,0,827.581c98.259,63.365,214.709,99.544,340.289,99.544,408.184,0,631.347-338.125,631.347-631.212,0-9.806-.338-19.273-.811-28.673C1014.848,236,1051.839,196.978,1082,152.075Z" transform="translate(0 -48)" fill="#03a9f4" />
                      </svg>
                    </label>
                    <div className='app-sublistapp-actiontop'>
                      <span className='btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt' onClick={() => deleteTwitter(usInt._id)}>
                        <svg id='Group_29020' data-name='Group 29020' xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'>
                          <rect id='Rectangle_135' data-name='Rectangle 135' width='1.264' height='5.509' transform='translate(7.785 5.664)' fill='#f06548'></rect>
                          <path id='Path_162' data-name='Path 162' d='M-127.23,5.132V2.295h-6.927V5.132H-137.7V6.386h2.122V16.3h9.755V6.386h2.123V5.132ZM-128.5,3.559V5.132h-4.41V3.559Zm-5.765,11.482V6.386h7.185v8.655Z' transform='translate(137.699 -2.295)' fill='#f06548'></path>
                          <rect id='Rectangle_136' data-name='Rectangle 136' width='1.254' height='5.509' transform='translate(4.959 5.664)' fill='#f06548'></rect>
                        </svg>
                      </span>
                    </div>
                  </div>
                  <div className='wdgt-group-input wdgt-group-integra-addtext wdgt-taghash-twitter  mv-16 '>
                    <div className="label-toltip">
                      <label>UserName/HashTag</label>
                      {/* <div className="connect-list-tooltip">
              <img data-tip data-for="fsdfs" src={IconInformation} alt="" />
              <ReactTooltip id="fsdfs" aria-haspopup='true' role='example'>
                <p>Use <b>'@'</b>  for username. Use  <b>'#'</b>  for hashtag</p>
              </ReactTooltip>
            </div> */}
                    </div>
                    <div className='wdgt-group-integra-btn-input'>
                      <Dropdown
                        className="nf-select-dropdown nf-select-defaultdd  nf-select-conditondd nf-select-desgn"
                        name="tgOption"
                        options={tagOptions}
                        defaultValue={data.tgOption}
                        value={data.tgOption}
                        onChange={(e) => handleStateChangeDrpDOWN(e, 'tgOption')}
                      />
                      <input className="nf-input nf-input-sm" name="slug"
                        placeholder={data.tgOption == '@' ? 'Enter your UserName' :
                          'Enter HashTag'}
                        value={data.slug}
                        onChange={handleStateChangeInt}
                      />
                      {validator.message('UserName/HashTag', data.slug, 'required|required')}
                      <div className="add-integra-btn text-center" onClick={(e) => createTwitterUN(e, userIntegration[0])}>
                        <a className="nf-btn nf-btn-default">Add New</a>
                      </div>
                    </div>
                  </div>
                  <div className='sublistapp-connect-block'>
                    <h5 className='title-connection'>Connection page</h5>
                  </div>
                  <div className='integra-data-headerblock'>
                    <label className=''>Username/ Hashtag</label>
                    <label className=''>Action</label>
                  </div>
                  <div className="card-intigra-box review-collection-scrollnot" >
                    {/* <div className="card-intigra-box review-collection-scroll" style={{ maxHeight: 'calc(100vh - 430px)' }}> */}
                    {usInt.d && usInt.d.twitUserNames && usInt.d.twitUserNames.length > 0 && usInt.d.twitUserNames.length > 0
                      ? usInt.d.twitUserNames.map((pageObj, i) => {
                        let objCountParams = {
                          pglkcnt: 0,
                          pgflcnt: 0,
                          pgrtngcnt: 0,
                          pgrtngavg: 0,
                          pu: '',
                          iin: usInt.inm,
                          rmk: pageObj.slug,
                          dn: usInt.d.dn ? usInt.d.dn : ''
                        };
                        pageObj.id = usInt._id;
                        if (data.twitterUNid == pageObj._id && pageObj.id == data.usIntId) pageObj.itwtpst = data.itwtpst ? true : false;
                        if (data.twitterUNid == pageObj._id && pageObj.id == data.usIntId) pageObj.itwtrpls = data.itwtrpls ? true : false;
                        if (data.twitterUNid == pageObj._id && pageObj.id == data.usIntId) pageObj.itwtrtwt = data.itwtrtwt ? true : false;
                        objCountParams.itwtpst = pageObj.itwtpst;
                        objCountParams.itwtrpls = pageObj.itwtrpls;
                        objCountParams.itwtrtwt = pageObj.itwtrtwt;
                        // let isChecked = arrDataSource.filter((dataSource) => {
                        //   if (dataSource.uid == usInt._id && dataSource.pid == pageObj._id) return true; return false;
                        // }).length > 0 ? true : false;
                        return <div className="dataset-select-list" key={i}>
                          <div className="dataset-select-item">
                            {/* <div className="secstyle-checkbox  itgtion-icon-checkboc">
                        <label>
                          <input type="checkbox"
                            name={pageObj.slug}
                            checked={isChecked}
                            onChange={(e) => handleDataSource(
                              usInt._id,
                              pageObj._id,
                              e.target.checked,
                              objCountParams,
                              usInt
                            )}
                          />
                        </label>
                      </div> */}
                            <h5>{pageObj.slug}</h5>
                            <div className="dataset-slcitem-right">
                              <div className={`dd-default dd-dataset ${data.isOpenCloseFilter && data.twitterUNid == pageObj._id ? 'dd-default-open' : ''}`}>
                                <div className="btn-action nf-btn light-bg-icon btn-icon-20 mr-3" onClick={() => openCloseFilter(pageObj._id)}>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="9.24" height="9.496" viewBox="0 0 9.24 9.496">
                                    <g id="Group_390" data-name="Group 390" transform="translate(-118.75 -203.75)">
                                      <path id="Path_237" data-name="Path 237" d="M252.774,208.385v-4.132a.253.253,0,1,0-.506,0v4.132a1.284,1.284,0,0,0,0,2.517v1.839a.253.253,0,1,0,.506,0V210.9a1.284,1.284,0,0,0,0-2.517Zm-.253,2.036a.778.778,0,0,1-.777-.777c0-.429.348.4.777.4s.777-.83.777-.4a.778.778,0,0,1-.777.777Zm0,0" transform="translate(-129.142)" fill="#8fa7c4" stroke="#8fa7c4" stroke-width="0.5" />
                                      <path id="Path_238" data-name="Path 238" d="M120.536,206.264v-2.012a.253.253,0,1,0-.506,0v2.012a1.284,1.284,0,0,0,0,2.517v3.96a.253.253,0,1,0,.506,0V208.78a1.283,1.283,0,0,0,0-2.516Zm-.253,2.036a.778.778,0,0,1-.777-.777c0-.429.348.366.777.366s.777-.794.777-.366a.779.779,0,0,1-.777.777Zm0,0" fill="#8fa7c4" stroke="#8fa7c4" stroke-width="0.5" />
                                      <path id="Path_239" data-name="Path 239" d="M384.216,206.264v-2.012a.253.253,0,1,0-.506,0v2.012a1.284,1.284,0,0,0,0,2.517v3.962a.253.253,0,0,0,.506,0V208.78a1.283,1.283,0,0,0,0-2.516Zm-.253,2.036a.778.778,0,0,1-.777-.777c0-.429.348.475.777.475s.777-.9.777-.475a.778.778,0,0,1-.777.777Zm0,0" transform="translate(-257.507)" fill="#8fa7c4" stroke="#8fa7c4" stroke-width="0.5" />
                                    </g>
                                  </svg>
                                </div>
                                <div className="dd-default-block">
                                  <div className="dd-arrow"></div>
                                  <div className="dd-default-title">Filter</div>
                                  <div className="dd-default-box">
                                    <div className="dataset-filter-item">
                                      <span>Show original tweet</span>
                                      <div className="sm-switch">
                                        <label className="switch">
                                          <input
                                            type="checkbox"
                                            defaultChecked={pageObj.itwtpst}
                                            name="itwtpst"
                                            onChange={(e) => {
                                              updateFilter(usInt._id, pageObj, e, true, objCountParams, 'twitterpost');
                                            }}
                                          />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="dataset-filter-item">
                                      <span>Show reply tweet</span>
                                      <div className="sm-switch">
                                        <label className="switch">
                                          <input
                                            type="checkbox"
                                            name="itwtrpls"
                                            defaultChecked={pageObj.itwtrpls}
                                            onChange={(e) => {
                                              updateFilter(usInt._id, pageObj, e, true, objCountParams, 'twitterpost');
                                            }}
                                          />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div className="dataset-filter-item">
                                      <span>Show re-tweet</span>
                                      <div className="sm-switch">
                                        <label className="switch">
                                          <input
                                            type="checkbox"
                                            name="itwtrtwt"
                                            defaultChecked={pageObj.itwtrtwt}
                                            onChange={(e) => {
                                              updateFilter(usInt._id, pageObj, e, true, objCountParams, 'twitterpost');
                                            }}
                                          />
                                          <span className="slider round"></span>
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
                                onClick={() => deleteTwitterUN(pageObj)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                  <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                    <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                    <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                  </g>
                                </svg>
                              </span>
                            </div>

                          </div>
                        </div>;
                      })
                      : <div className="dataset-select-list" >
                        <div className="dataset-select-item"> <h5> No record found</h5></div></div>
                    }
                    {/* <div className="dataset-select-list">
                <div className="dataset-select-item">
                  <h5>sdasdas</h5>
                  <div className="dataset-slcitem-right">
                    <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt">
                      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                        <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                          <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360"></path>
                          <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360"></path>
                        </g>
                      </svg>
                    </span>
                  </div>
                </div>
              </div> */}
                  </div>
                </div>);
              }) : ''
          }
        </div>}
      {/* <div classNameName="integre-search--list">
        <input
          className="nf-input nf-input-sm input-left-inicon input-left-iconsearch input-left-visitor"
          placeholder="Search by name"
          type="text"
          name="searchByName"
          value={data.searchByName}
          onChange={(e) => handleStateChangeInt(e)}
        />
      </div> */}
      {/* {data.islstIntLoading === true ?
        <ContentLoader
          height={750}
          width={1750}
          speed={2}
          primaryColor="#fff"
          secondaryColor="#eceef4"
        >
          <rect x="150" y="40" rx="0" ry="0" width="1500" height="700"></rect>
        </ContentLoader>
        :
        userIntegration && userIntegration.length > 0 ?
          userIntegration.map((usInt, key) => {
            return (<div className="card-editor card-intigra-block mt-25" key={key}>
              <div className="card-editor-block p-0">
                <label className="card-editor-title app-intigra-title">{usInt.d && usInt.d.name ? usInt.d.name : ''}</label>
                <div className="app-editor-actiontop app-intigra-actiontop"> */}
      {/* <label className="switch">
                    <input type="checkbox"
                      checked={usInt.ia ? true : false}
                      onChange={(e) => handleIsActive(usInt._id, e.target.checked)}
                    />
                    <span className="slider round"></span>
                  </label> */}
      {/* <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt" onClick={() => deleteTwitter(usInt._id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                      <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                        <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                        <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                      </g>
                    </svg>
                  </span>
                </div>
                <div className="card-intigra-box">
                  {usInt.d && usInt.d.twitUserNames && usInt.d.twitUserNames.length > 0 && usInt.d.twitUserNames.length > 0
                    ? usInt.d.twitUserNames.map((pageObj, i) => {
                      let objCountParams = {
                        pglkcnt: 0,
                        pgflcnt: 0,
                        pgrtngcnt: 0,
                        pgrtngavg: 0,
                        pu: '',
                        iin: usInt.inm,
                        rmk: pageObj.slug,
                        dn: usInt.d.dn ? usInt.d.dn : ''
                      };
                      pageObj.id = usInt._id;
                      if (data.twitterUNid == pageObj._id && pageObj.id == data.usIntId) pageObj.itwtpst = data.itwtpst ? true : false;
                      if (data.twitterUNid == pageObj._id && pageObj.id == data.usIntId) pageObj.itwtrpls = data.itwtrpls ? true : false;
                      if (data.twitterUNid == pageObj._id && pageObj.id == data.usIntId) pageObj.itwtrtwt = data.itwtrtwt ? true : false;
                      objCountParams.itwtpst = pageObj.itwtpst;
                      objCountParams.itwtrpls = pageObj.itwtrpls;
                      objCountParams.itwtrtwt = pageObj.itwtrtwt;
                      let isChecked = arrDataSource.filter((dataSource) => {
                        if (dataSource.uid == usInt._id && dataSource.pid == pageObj._id) return true; return false;
                      }).length > 0 ? true : false;
                      return <div className="dataset-select-list" key={i}>
                        <div className="dataset-select-item">
                          <div className="secstyle-checkbox  itgtion-icon-checkboc">
                            <label>
                              <input type="checkbox"
                                name={pageObj.slug}
                                checked={isChecked}
                                onChange={(e) => handleDataSource(
                                  usInt._id,
                                  pageObj._id,
                                  e.target.checked,
                                  objCountParams,
                                  usInt
                                )}
                              />
                            </label>
                          </div>
                          <h5>{pageObj.slug}</h5>
                          <div className="dataset-slcitem-right">
                            <div className={`dd-default dd-dataset ${data.isOpenCloseFilter && data.twitterUNid == pageObj._id ? 'dd-default-open' : ''}`}>
                              {(isChecked == true || document.getElementsByName(pageObj.slug) && document.getElementsByName(pageObj.slug).length > 0 && document.getElementsByName(pageObj.slug)[0].checked == true) && <div className="btn-action nf-btn light-bg-icon btn-icon-20 mr-3" onClick={() => openCloseFilter(pageObj._id)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="9.24" height="9.496" viewBox="0 0 9.24 9.496">
                                  <g id="Group_390" data-name="Group 390" transform="translate(-118.75 -203.75)">
                                    <path id="Path_237" data-name="Path 237" d="M252.774,208.385v-4.132a.253.253,0,1,0-.506,0v4.132a1.284,1.284,0,0,0,0,2.517v1.839a.253.253,0,1,0,.506,0V210.9a1.284,1.284,0,0,0,0-2.517Zm-.253,2.036a.778.778,0,0,1-.777-.777c0-.429.348.4.777.4s.777-.83.777-.4a.778.778,0,0,1-.777.777Zm0,0" transform="translate(-129.142)" fill="#8fa7c4" stroke="#8fa7c4" stroke-width="0.5" />
                                    <path id="Path_238" data-name="Path 238" d="M120.536,206.264v-2.012a.253.253,0,1,0-.506,0v2.012a1.284,1.284,0,0,0,0,2.517v3.96a.253.253,0,1,0,.506,0V208.78a1.283,1.283,0,0,0,0-2.516Zm-.253,2.036a.778.778,0,0,1-.777-.777c0-.429.348.366.777.366s.777-.794.777-.366a.779.779,0,0,1-.777.777Zm0,0" fill="#8fa7c4" stroke="#8fa7c4" stroke-width="0.5" />
                                    <path id="Path_239" data-name="Path 239" d="M384.216,206.264v-2.012a.253.253,0,1,0-.506,0v2.012a1.284,1.284,0,0,0,0,2.517v3.962a.253.253,0,0,0,.506,0V208.78a1.283,1.283,0,0,0,0-2.516Zm-.253,2.036a.778.778,0,0,1-.777-.777c0-.429.348.475.777.475s.777-.9.777-.475a.778.778,0,0,1-.777.777Zm0,0" transform="translate(-257.507)" fill="#8fa7c4" stroke="#8fa7c4" stroke-width="0.5" />
                                  </g>
                                </svg>
                              </div>}
                              <div className="dd-default-block">
                                <div className="dd-arrow"></div>
                                <div className="dd-default-title">Filter</div>
                                <div className="dd-default-box">
                                  <div className="dataset-filter-item">
                                    <span>Show original tweet</span>
                                    <div className="sm-switch">
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          defaultChecked={pageObj.itwtpst}
                                          name="itwtpst"
                                          onChange={(e) => {
                                            updateFilter(usInt._id, pageObj, e, true, objCountParams, 'twitterpost');
                                          }}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="dataset-filter-item">
                                    <span>Show reply tweet</span>
                                    <div className="sm-switch">
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          name="itwtrpls"
                                          defaultChecked={pageObj.itwtrpls}
                                          onChange={(e) => {
                                            updateFilter(usInt._id, pageObj, e, true, objCountParams, 'twitterpost');
                                          }}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                  <div className="dataset-filter-item">
                                    <span>Show re-tweet</span>
                                    <div className="sm-switch">
                                      <label className="switch">
                                        <input
                                          type="checkbox"
                                          name="itwtrtwt"
                                          defaultChecked={pageObj.itwtrtwt}
                                          onChange={(e) => {
                                            updateFilter(usInt._id, pageObj, e, true, objCountParams, 'twitterpost');
                                          }}
                                        />
                                        <span className="slider round"></span>
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <span className="btn-action nf-btn  btn-delete-light  light-bg-icon btn-icon-20  tbl-action-dlt"
                              onClick={() => deleteTwitterUN(pageObj)}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 176 192">
                                <g id="Group_8307" data-name="Group 8307" transform="translate(-8)">
                                  <path id="Path_12759" data-name="Path 12759" d="M128,32V24A24.027,24.027,0,0,0,104,0H88A24.027,24.027,0,0,0,64,24v8H8V48H184V32ZM80,24a8.009,8.009,0,0,1,8-8h16a8.009,8.009,0,0,1,8,8v8H80Z" fill="#fb5360" />
                                  <path id="Path_12760" data-name="Path 12760" d="M30.467,170.651A23.976,23.976,0,0,0,54.321,192h83.358a23.976,23.976,0,0,0,23.854-21.35L174.272,56H17.728Zm87.561-99.316,15.944,1.33-8,96-15.944-1.33Zm-44.056,0,8,96-15.944,1.33-8-96Z" fill="#fb5360" />
                                </g>
                              </svg>
                            </span>
                          </div>

                        </div>
                      </div>;
                    })
                    : 'No record found'
                  }
                </div>
              </div>
            </div>);
          })
          : ''
      } */}
    </div>
  );
};

export default TwitterPost;


// WEBPACK FOOTER //
// ./src/components/Integration/TwitterPost.js